import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, {css} from 'styled-components';
import { rgba } from 'polished';
import { find, filter, uniqBy, reject } from 'lodash';
import { Link } from 'react-router-dom'
import moment from 'moment'
import Masonry from 'react-masonry-component';
import Fade from 'react-reveal/Fade';

import { fetchSupporters, getSupporters } from './redux';
import { fetchPage, getPages } from '../Page/redux';

import { Select } from '../../components'

import Chain from 'svg-react-loader?name=Icon!../../assets/icons/chain.svg';

import { paleGreen } from '../../styles/colors';
import { hoverState, body, padding, container, bgImage, bgIcon } from '../../styles/global';
import { media } from '../../styles/utils';
import MetaTags from '../../components/MetaTags/MetaTags';


class Supporters extends Component {

    state = {
        selectedCountry: null,
        selectedDiscipline: null,
        selectedType: null
    }

    componentWillMount() {
        const {fetchSupporters,fetchPage} = this.props;
        fetchSupporters();    
        fetchPage('supporters');
    }

    renderTaxTerms = (data) => {
        if (data) {
            const terms = data.map((term, index) => {
                return (
                    <Term
                        slug={term.slug}
                        key={index}
                    >
                        {term.name}
                    </Term>
                )
            })
            return (
                <TermsContainer>{terms}</TermsContainer>
            )
        }
    }

    renderPartners = () => {
        const {supporters, pages} = this.props;
        const pageData = find(pages, (o) => { return o.slug == 'supporters' })
        const industryPartners = filter(supporters.data, {supporter_type: [{ slug: 'industry-partner' }]})
     
        if (pageData && industryPartners) {
    
            const items = industryPartners.map((item, index) => {
                return (
                    <Partner
                        key={index}
                    >
                        <Logo image={item.logo} />
                        <Title>{item.title}</Title>
                    
                        {item.types.length > 0 && (
                            <PartnerMeta>{item.types[0].name}</PartnerMeta>
                        )}

                        <PartnerMeta>{item.location}</PartnerMeta>
    
                        {item.website && (
                            <PartnerMetaLink
                                href={item.website}
                                target="_blank"
                            >
                                Website
                            </PartnerMetaLink>
                        )}             
                    </Partner>
                )
            })

            if (pageData) {
                return (
                    <Partners>
                        <PartnersHeading>Industry Partners</PartnersHeading>
                        <PartnersList>
                            {items}
                        </PartnersList>
                    </Partners>
                )
            }
        }
    }

    onSelectChange = (value, type) => {
        this.setState({
            [`selected${type}`]: value.value == 'all' ? null : value.value
        })
    }

    renderSupporterFilters = () => {
        const {supporters} = this.props;
        const { selectedCountry, selectedDiscipline, selectedType } = this.state;

        if (supporters.data) {
            
            let supportersData = reject(supporters.data, {supporter_type: [{ slug: 'industry-partner' }]});

            // Country Options

            let countries = []

            supportersData.forEach((supporter, index) => {
                for (let val of supporter.countries) {
                    countries.push(val);
                }
            })

            countries = uniqBy(countries, 'slug');

            const countryOptions = countries.map((item, index) => {
                return (
                    { value : item.slug, label: item.name }
                )
            })
            
            countryOptions.unshift({ value : 'all', label: 'All' })
            
            // Discipline Options

            let disciplines = []

            supportersData.forEach((supporter, index) => {
                for (let val of supporter.disciplines) {
                    disciplines.push(val);   
                }
            })

            disciplines = uniqBy(disciplines, 'slug');

            const disciplineOptions = disciplines.map((item, index) => {
                return (
                    { value : item.slug, label: item.name }
                )
            })
            
            disciplineOptions.unshift({ value : 'all', label: 'All' })
            
            // Type Options
            
            let types = []

            supportersData.forEach((supporter, index) => {
                for (let val of supporter.types) {
                    types.push(val);   
                }
            })

            types = uniqBy(types, 'slug');

            const typeOptions = types.map((item, index) => {
                return (
                    { value : item.slug, label: item.name }
                )
            })
            
            typeOptions.unshift({ value : 'all', label: 'All' })

            return (
                <Filters>
                    <FilterBy>Filter By</FilterBy>
                    <Select
                        options={countryOptions}
                        placeholder={'Country'}
                        onSelectChange={(value) => this.onSelectChange(value, 'Country')}
                    />
                    <Select
                        options={disciplineOptions}
                        placeholder={'Discipline'}
                        onSelectChange={(value) => this.onSelectChange(value, 'Discipline')}
                    />  
                    <Select
                        options={typeOptions}
                        placeholder={'Type'}
                        onSelectChange={(value) => this.onSelectChange(value, 'Type')}
                    />

                    {(selectedCountry || selectedDiscipline || selectedType) && (
                        <ShowAll
                            onClick={() => {
                                this.setState({
                                    selectedCountry: null,
                                    selectedDiscipline: null,
                                    selectedType: null
                                })
                            }}
                        >
                            Show All
                        </ShowAll>
                    )}
                </Filters>
            )

        }
    }

    renderSupporterItems = () => {
        const { supporters } = this.props;
        const { selectedCountry, selectedDiscipline, selectedType } = this.state;

        let newSupporters = reject(supporters.data, {supporter_type: [{ slug: 'industry-partner' }]});

        if (selectedCountry) {
            newSupporters = filter(newSupporters, { countries: [{ slug: selectedCountry }] });
        }

        if (selectedDiscipline) {
            newSupporters = filter(newSupporters, { disciplines: [{ slug: selectedDiscipline }] });
        }

        if (selectedType) {
            newSupporters = filter(newSupporters, { types: [{ slug: selectedType }] });
        }

        console.log(supporters)

        const supporterItems = newSupporters.map((supporter, index) => {   
            console.log(supporter)
            return (
                <Supporter
                    key={index}
                >
                    <Top>
                        <Logo
                            image={supporter.logo}
                        />
                        <Info>
                            <Title>{supporter.name}</Title>
                            {supporter.business && (
                                <Title>{supporter.business}</Title>
                            )}
                            <Location>{`${supporter.location} ${supporter.countries[0].name}`}</Location>
                        </Info>
                    </Top>

                    <Disciplines>
                        <Heading>Disciplines</Heading>
                        {this.renderTaxTerms(supporter.disciplines)}      
                    </Disciplines>    

                    {supporter.website && (
                        <Website
                            href={supporter.website}
                            target="_blank"
                        >
                            <ChainIcon />
                            <Visit>Visit Website</Visit>
                        </Website>
                    )}
                </Supporter>
            )
        })

        return supporterItems
    }

    renderSupporters = () => {
        const {supporters, pages} = this.props;
        const pageData = find(pages, (o) => { return o.slug == 'supporters' })
        
        if (pageData && supporters.data) {

            return (
                <SupportersWrapper>
                    <SupportersHeading>Find a supporter</SupportersHeading>

                    <GridContainer>
                        {this.renderSupporterFilters()}
                        <Grid>
                            <Masonry
                                options={{
                                    gutter: 32,
                                    horizontalOrder: true
                                }}
                                disableImagesLoaded={false} // default false
                                updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
                            >
                                {this.renderSupporterItems()}
                            </Masonry>
                        </Grid>
                    </GridContainer>
                </SupportersWrapper>
            )
        }
    }
    
    render() {
        const {pages} = this.props;
        const pageData = find(pages, (o) => { return o.slug == 'supporters' })

        return (
            <Container>
                
                {pageData && (
                    <Fade
                        up
                        duration={1000}
                        distance={'50px'}
                    >
                        <Introduction>     
                            <Description
                                dangerouslySetInnerHTML={{__html: pageData.introduction}}
                            />

                            <MetaTags
                                title={`Supporters`}   
                                description={pageData.introduction}
                            />
                        </Introduction>
                    </Fade>
                )}
                
                
                {/* {this.renderPartners()}  */}
                {this.renderSupporters()}  
  
            </Container>
        )
    }
}

const Container = styled.div`
    background: white;
    min-height: 100vh;
    display: flex;
    align-items: center;
    flex-direction: column;
`

const Logo = styled.div`
    ${bgImage}
    background-image: url(${props => props.image});
    flex: 1;
    width: 100%;
`

const Title = styled.div``
const Heading = styled.div``

const containerPadding = css`
    padding: 0 115px;
    box-sizing: border-box;

    ${media.phone`
        ${padding}
    `}
`

// Introduction 

const Introduction = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 128px;
    margin-bottom: 128px;
    ${containerPadding}
    max-width: 1680px;

    ${media.tablet`
        flex-direction: column;
        justify-content: center;
        text-align: center;
        margin-top: 96px;
        margin-bottom: 128px;
    `}
`

const ImageWrapper = styled.div`
    flex: 0 1 50%;
    display: flex;
    justify-content: center;
    padding-top: 200px;

    ${media.tablet`
        padding-top: 80px;
    `}

    ${media.phone`
        padding-top: 48px;
    `}
`;

const Image = styled.div`
    ${bgImage}
    background-image: url(${props => props.image});
    width: 180px;
    height: 80px;

    ${media.phone`
        width: 140px;
        height: 60px;
    `}
`

const Description = styled.div`
    text-align: center;

    p {
        max-width: 740px;
        ${body}

        ${media.tablet`
            max-width: none;
        `}
    }
`;

// Partners

const Partners = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    ${containerPadding}
    width: 100%;
    max-width: 1680px;
`

const PartnersHeading = styled.div`
    font-family: Platform-Medium;
    font-size: 28px;
    color: #BABABA;
    letter-spacing: 0.17px;
    text-align: center;
    margin-bottom: 132px;

    ${media.tablet`
        margin-bottom: 96px;
    `}

    ${media.phone`
        margin-bottom: 64px;
    `}
`

const PartnersList = styled.div`
    display: flex;
    flex-flow: row wrap;

    ${media.phone`
        flex-direction: column;
    `}
`

const Partner = styled.div`
    flex: 0 1 33.2%;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin-bottom: 64px;

    ${Logo} {
        ${bgIcon}
        width: 120px;
        height: 54px;
        margin-bottom: 42px;
    }

    ${Title} {
        font-family: TiemposText-Regular;
        font-size: 15px;
        color: #A8A8A8;
        line-height: 9px;
        margin-bottom: 26px;
    }

    &:not(:nth-child(3n)) {
        border-right: 1px solid #E8E8E8;
    }

    ${media.tablet`
        max-width: none;
        flex: 0 1 49%;
        margin-bottom: 48px;

        &:not(:nth-child(3n)) {
            border: 0;
        }

        &:not(:nth-child(2n)) {
            border-right: 1px solid #E8E8E8;
        }
    `}

    ${media.phone`
        flex: 1;
        border: none !important;
    `}
`

const meta = css`
    font-family: 'Platform-Regular';
    font-size: 12px;
    color: #C0C0C0;
    letter-spacing: 1.02px;
    line-height: 9px;
    text-transform: uppercase;
    margin-bottom: 14px;
`

const PartnerMeta = styled.div`
    ${meta}
`

const PartnerMetaLink = styled.a`
    ${meta}
    ${hoverState}
`

// Supporters Grid

const SupportersWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-top: 150px;
`;

const SupportersHeading = PartnersHeading.extend`
    margin-bottom: 32px;
    text-align: left;
    color: #4D4D4D;
    max-width: 1024px;
    width: 100%;
    padding-left: 48px;

    ${media.tablet`
        margin-bottom: 32px;
    `}
`

// Filters

const Filters = styled.div`
    width: 100%;
    max-width: 1024px;
    padding-left: 48px;
    display: flex;
    align-items: center;

    > * {
        margin-right: 40px;
    }

    ${media.phone`
        flex-direction: column;
        align-items: flex-start;

        > * {
            margin-right: 0;
            margin-bottom: 18px;
        }
    `}
`

const FilterBy = styled.div`
    font-family: 'Platform-Regular';
    font-size: 14px;
    color: #5F5F5F;
    letter-spacing: 1.28px;
    line-height: 9px;
    text-transform: uppercase;
    margin-right: 24px;

    ${media.phone`
        margin-bottom: 32px;
    `}
`;

// Grid

const GridContainer = styled.div`
    background: #FCFCFC;
    border-top: 1px solid #F1F1F1;
    width: 100%;
    flex: 1;
    padding-top: 32px;
    padding-bottom: 100px;

    display: flex;
    flex-direction: column;
    align-items: center;
    
    ${media.phone`
        padding-top: 32px;
        padding-bottom: 64px;
    `}
`;

const Grid = styled.div`
    width: 100%;
    max-width: 1024px;
    padding-left: 32px;
    padding-top: 69px;
    min-height: 400px;

    ${media.phone`
        padding-top: 32px;
    `}
`;

// Supporter card

const Supporter = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(33.3% - 32px); 

    background: white;
    box-shadow: 0 3px 5px 0 rgba(0,0,0,0.01);
    border: 1px solid #F1F1F1;
    border-radius: 4px;
    overflow: hidden;

    box-sizing: border-box;
    margin-bottom: 30px;

    ${media.tablet`
        width: calc(50% - 32px); 
    `}

    ${media.phone`
        width: calc(100% - 32px); 
    `}
`;

const cardMeta = css`
    font-family: 'Platform-Regular';
    font-size: 13px;
    color: #807c7c;
    letter-spacing: 1.19px;
    line-height: 9px;
    text-transform: uppercase;
`

const Top = styled.div`
    display: flex; 
    justify-content: space-between;
    padding: 32px 32px 20px;
    border-bottom: 1px solid #F1F1F1;

    ${Logo} {
        flex: 0 1 100px;
        height: 100px;
        margin-right: 32px;
        ${bgImage}
        border-radius: 4px;
    }
`

const Info = styled.div`
    display: flex;  
    flex-direction: column;
    width: 50%;

    ${Title} {
        font-family: TiemposText-Bold;
        font-size: 14px;
        color: #5F5F5F;
        text-align: right;
        line-height: 20px;
        margin-bottom: 8px;

        &:first-child {
            margin-bottom: 6px;
        }

        &:nth-child(2) {
            font-family: 'TiemposText-BoldItalic';
        }
    }
`;

const Location = styled.div`
    font-family: TiemposText-Regular;
    font-size: 14px;
    color: #5F5F5F;
    text-align: right;
    line-height: 18px;
    line-height: 22px;
`;

const Disciplines = styled.div`
    border-bottom: 1px solid #F1F1F1;
    padding: 20px 32px 10px;

    ${Heading} {
        ${cardMeta}
        color: #5F5F5F;
        margin-bottom: 16px;
    }
`

const TermsContainer = styled.div`
    display: flex;
    flex-flow: row wrap;
`

const Term = styled.div`
    ${cardMeta}
    margin-bottom: 10px;

    &:not(:last-child) {
        margin-right: 20px;
    }
`

const Website = styled.a`
    padding: 25px 32px;
    display: flex;
    justify-content: space-between;
    ${hoverState}
`

const ChainIcon = styled(Chain)``

const Visit = styled.div`
    ${cardMeta}
`

const ShowAll = styled.div`
    font-family: 'Platform-Regular';
    font-size: 14px;
    color: #5F5F5F;
    letter-spacing: 1.28px;
    line-height: 9px;
    text-transform: uppercase;
    margin-left: auto;
    cursor: pointer;
    ${hoverState};
`




const mapDispatchToProps = dispatch => ({
    fetchSupporters() {
        dispatch(fetchSupporters())
    },
    fetchPage(slug) {
        dispatch(fetchPage(slug))
    }
})

const mapStateToProps = (state, props) => ({
    supporters: getSupporters(state),
    pages: getPages(state)
})

export default connect(mapStateToProps, mapDispatchToProps)(Supporters);



// WEBPACK FOOTER //
// ./client/modules/Supporters/Supporters.js